import { MutableRefObject } from 'react';
import { useLiveSections } from '@utils/providers/use-live-sections.ts';
import { useLiveTranscript } from '@utils/providers/use-live-transcript.ts';
import { LiveDraft } from '@utils/editors/live-transcript-state.ts';
import { LiveTranscriptNotices } from './live-transcript-notices.tsx';

type Props = {
  live: ReturnType<typeof useLiveTranscript>;
  sections: ReturnType<typeof useLiveSections>;
  embedded: boolean;
  visibleRows: LiveDraft[];
  canEdit: boolean;
  draftExit: MutableRefObject<((after: () => void) => void) | null>;
};

export const LiveTranscriptSectionNotices = ({
  live,
  sections,
  embedded,
  visibleRows,
  canEdit,
  draftExit
}: Props) => {
  const selected = sections.selected;
  const hiddenDirtyRows = selected
    ? live.rows.filter(
        row =>
          row.dirty &&
          (selected.completed ||
            row.segment.sequence < selected.start_sequence ||
            row.segment.sequence > selected.end_sequence)
      ).length
    : 0;
  const back = () => {
    const showEntireTranscript = () => {
      void sections.select('');
    };
    if (draftExit.current) draftExit.current(showEntireTranscript);
    else showEntireTranscript();
  };
  return (
    <LiveTranscriptNotices
      live={live}
      embedded={embedded}
      section={
        selected
          ? {
              name: selected.name,
              completed: selected.completed,
              visibleRows: visibleRows.length,
              totalRows: live.rows.length,
              hiddenDirtyRows,
              busy: sections.busy,
              canEdit,
              onBack: back
            }
          : undefined
      }
    />
  );
};
